import { atom } from 'jotai';

export interface Location {
  href: string;
  path: string;
  hasNav?: boolean;
  origin: string;
}

export const $LegalLocation = atom<Location>({
  href: '',
  path: '',
  hasNav: true,
  origin: '',
});

$LegalLocation.debugLabel = '$LegalLocation';
